import { UploadInProgressAction, UploadWorkbookActions, UploadWorkbookActionsTypes } from '../actions/UploadWorkbookActions';

export type UploadWorkbook = Omit<UploadInProgressAction, 'type'>;

export interface UploadWorkbookState {
  readonly uploads: Map<string, UploadWorkbook>;
}

const defaultState: UploadWorkbookState = {
  uploads: new Map()
};

export function uploadWorkbookReducer(previousState: UploadWorkbookState = defaultState, action: UploadWorkbookActions): UploadWorkbookState {
  switch(action.type) {
    case UploadWorkbookActionsTypes.IN_PROGRESS: {
      const updatedAction = {
        ...previousState.uploads.get(action.id),
        ...action
      };
      const updatedUploads = new Map(previousState.uploads);
      updatedUploads.set(action.id, updatedAction);
      return {
        ...previousState,
        uploads: updatedUploads
    };
    }
    case UploadWorkbookActionsTypes.REMOVE_UPLOAD: {
      const updatedUploads = new Map(previousState.uploads);
      updatedUploads.delete(action.id);
      return {
        ...previousState,
        uploads: updatedUploads
      };
    }
    default: {
      return previousState;
    }
  }
}
